import { $t } from "@/plugins/i18n";

export default {
  path: "/extra",
  redirect: "/device/deviceList/index",
  meta: {
    icon: "informationLine",
    title: $t("menus.device"),
    showLink: false,
    rank: 800
  },
  children: [
    {
      path: "/extra/deviceDetail/index",
      name: "DeviceDetail",
      component: () => import("@/views/device/deviceDetail/index.vue"),
      meta: {
        title: $t("menus.deviceDetail")
      }
    },
    {
      path: "/extra/deviceDetail/aisle-8",
      name: "DeviceDetail-8",
      component: () => import("@/views/device/deviceDetail/aisle-8/index.vue"),
      meta: {
        title: $t("menus.deviceDetail")
      }
    },
    {
      path: "/extra/dbcParse/index",
      name: "ParseFileDBCParse",
      component: () => import("@/views/parseFile/dbcParse/index.vue"),
      meta: {
        title: $t("menus.parseFileDBCParse")
      }
    }
  ]
} as RouteConfigsTable;
